<template>
  <div class="page-wrap">
    <Header></Header>
    <login-view></login-view>
    <el-tooltip content placement="left" effect="light" popper-class="sub-poper-class">
      <div class="contact-us flex-dir-center flex-r-center">
        <img src="@/assets/image-contact-us.png" alt />
        <div class="mt5">联系我们</div>
      </div>
      <div slot="content" class="flex-center pl10 pr20">
        <img class="mr10" src="@/assets/icon-phone.png" alt />
        <div>
          <div class="fc9 fz14">服务热线：</div>
          <div class="fz12 fc3 mt5">0411-82951884</div>
        </div>
      </div>
    </el-tooltip>
    <Bottom></Bottom>
  </div>
</template>
<script>
import LoginView from "./components/LoginView.vue";
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
export default {
  components: { LoginView, Bottom, Header },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="less" scoped>
.contact-us {
  width: 65px;
  position: fixed;
  right: 0;
  top: 30%;
  z-index: 999;
  height: 84px;
  background-color: #3e4359;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  margin-bottom: 10px;
}
</style>
